import { render, staticRenderFns } from "./MemoList.vue?vue&type=template&id=ddd89bb6&"
import script from "./MemoList.vue?vue&type=script&lang=js&"
export * from "./MemoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports